/**
 * 货品相关处理
 */
export default {
    data () {
        return {
            productInfo : {
                mark: 0
            }, // 列表中的对象基础数据，此数据应该根据配置生成
            productList: [], // 货品列表
            deleteList: [], // 需要删除商品的列表
            functionList: [] // 货品变化后的需要执行的函数
        }
    },
    methods: {
        /**
         * 初始化货品对象的字段
         */
        initProductField () {
            for (let i in this.theadConfig) {
                // 函数的配置
                if (this.theadConfig[i].type && this.theadConfig[i].type === 'function') {
                    this.functionList.push(this.theadConfig[i]['func'])
                } else {
                    if (this.theadConfig[i].json && this.theadConfig[i].json.prop) {
                        this.productInfo[this.theadConfig[i].prop] = {}
                    } else if (this.theadConfig[i].default) {
                        this.productInfo[this.theadConfig[i].prop] = this.theadConfig[i].default
                    } else {
                        this.productInfo[this.theadConfig[i].prop] = ''
                    }
                }
            }
        },
        /**
         * 添加一个商品
         */
        create () {
            // this.pushProduct(this.productInfo)
            this.pushProduct(JSON.parse(JSON.stringify(this.productInfo)))
        },
        /**
         * 添加货品到列表中 
         */
        pushProduct (product) {
            // 克隆基础product对象
            let obj = this.$utils.deepClone(this.productInfo)
            // 字段补齐
            obj = Object.assign(obj, this.$utils.deepClone(product))
            // 生成标识
            obj.mark = new Date().getTime() + parseInt((Math.random() + 1) * 100)
            // 添加到列表中
            this.productList.push(obj)
        },
        /**
         * 删除商品
         * @param  {[Array]} arr [要删除的商品列表]
         */
        deleteProduct (arr) {
            for (let i in arr) {
                let index = this.productList.findIndex(function (val) {
                    return val.mark === arr[i]['mark']
                })
                if (index >= 0) {
                    this.productList.splice(index, 1)
                }
            }
        },
        /**
         * 多选监听
         * @param  {[Array]} select [选中的列]
         */
        handleSelectionChange (select) {
            this.deleteList = select
        },
        /**
         * 获取货品数据
         * @return {[type]} [description]
         */
        getProductData () {
            return this.productList
        }
    }
}